export default __webpack_public_path__ + "static/img3-63b8a9bd898e2dea0e3fe9cdaae7d267.png";